export interface CustomerReference {
  customerReferenceId: number;
  nominationId: number;
  prefix: string;
  firstName: string;
  lastName: string;
  title: string;
  emailAddress: string;
  phoneNumber: string;
  companyName: string;
  description: string;
}

export function blankCustomerReference(): CustomerReference {
  return {
    customerReferenceId: 0,
    nominationId: 0,
    prefix: '',
    firstName: '',
    lastName: '',
    title: '',
    emailAddress: '',
    phoneNumber: '',
    companyName: '',
    description: '',
  };
}

export function copyCustomerReference(c: CustomerReference): CustomerReference {
  return {
    companyName: c.companyName,
    customerReferenceId: c.customerReferenceId,
    description: c.description,
    emailAddress: c.emailAddress,
    firstName: c.firstName,
    lastName: c.lastName,
    nominationId: c.nominationId,
    phoneNumber: c.phoneNumber,
    prefix: c.prefix,
    title: c.title,
  };
}
